import React, { useEffect, useState } from 'react';

import { Button } from 'primereact/button';
import { Tooltip } from 'primereact/tooltip';
import { useSecureMessageContext } from 'modules/messages/SecureMessages/Context/SecureMessageContext';
import CaseListDropDown from 'components/CaseListDropDown/CaseListDropDown';
import { useWebSocketContext } from 'context/WebSocketConnectionContext';
import GlobalTooltip from 'components/GlobalTooltip';
import { useUserDetailsContext } from 'context/userDetailsContext';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import useCaseNoteDownload from 'hooks/useCaseNoteDownload';

function CaseName({
  showCaseSearch,
  messageDetails,
  redirectToPage,
  selectedMessage,
  setSelectedCase,
  setShowCaseSearch,
  setShowInviteUsers,
  setShowConfirmDialog,
  selectedCase,
  checkCaseRelatedUser,
  caseUserClients,
  loadCaseContacts,
  showSideBar,
  setShowSideBar,
  handleMarkAsUnRead,
  hasPermission,
  loadFirmUserList,
  firmUserList,
}) {
  const { isLeadSpecific, isGlobalMessagesScreen, isFromClientPortal, updateMessageThread } = useSecureMessageContext();
  const { checkSubPermission } = useUserDetailsContext();
  const { sideBarMessages } = useWebSocketContext();
  const { downloadCaseNotesAsPDF } = useCaseNoteDownload();

  const [caseError, setCaseError] = useState('');
  const [newMsg, setNewMsg] = useState(messageDetails?.is_sidebar_message_read === false);

  useEffect(() => {
    if (sideBarMessages && sideBarMessages?.message_thread_id === messageDetails?.message_thread_id) {
      setNewMsg(true);
    }
  }, [sideBarMessages]);

  const handleSidebar = () => {
    setShowSideBar((preVal) => !preVal);
    setNewMsg(false);
  };

  useEffect(() => {
    if (messageDetails?.case_id) {
      let isForMessageLinkedCase = true;
      loadCaseContacts(messageDetails?.case_id, isForMessageLinkedCase);
    }
  }, [messageDetails]);

  const handlePrintPDF = (downloadType = 'secure_message') => {
    if (messageDetails?.case_id) {
      downloadCaseNotesAsPDF(messageDetails.case_id, {
        case_name: messageDetails?.case_name,
        download_type: downloadType,
        message_thread_pk: messageDetails?.pk,
      });
    }
  };

  return (
    <div className="row mb-4">
      <div className="col-sm-12">
        {!showCaseSearch ? (
          <>
            <div className="d-flex justify-content-between flex-wrap gap-3">
              <div className="d-flex align-items-center">
                <span className="text-bold me-2 text-nowrap">Case : </span>
                <Link
                  to={
                    isLeadSpecific || messageDetails?.is_lead
                      ? messageDetails?.case_id
                        ? `/leads/${messageDetails?.case_id}`
                        : '/leads'
                      : messageDetails?.case_id
                      ? `/cases/${messageDetails?.case_id}`
                      : '/cases'
                  }
                  className="redirection-link-no-text-transform"
                >
                  <span
                    onClick={(e) => {
                      let route = '/';
                      if (isLeadSpecific || messageDetails?.is_lead) {
                        messageDetails.case_id ? (route = `/leads/${messageDetails.case_id}`) : (route = '/leads');
                      } else {
                        messageDetails.case_id ? (route = `/cases/${messageDetails.case_id}`) : (route = '/cases');
                      }

                      redirectToPage(e, route);
                    }}
                    className="cursor-pointer text-primary-dark text-decoration-none case-details-link"
                  >
                    {messageDetails?.case_name ? messageDetails.case_name : selectedMessage?.case_name ? selectedMessage.case_name : ''}
                  </span>
                </Link>
                {isGlobalMessagesScreen && (
                  <>
                    <span
                      className="pointer px-2  ms-3 me-2"
                      onClick={() => {
                        setSelectedCase('');
                        setShowCaseSearch(true);
                        setShowInviteUsers(false);
                      }}
                    >
                      <i className="icon-edit fa-lg"></i>
                      <Tooltip content="Edit Case Name" position="top" target=".icon-edit" showDelay={500} />
                    </span>
                  </>
                )}
              </div>
              <div className="d-flex align-items-center flex-wrap gap-2">
                <Button
                  label="Download"
                  className="btn-outline p-button-secondary p-button-secondary outline py-1 px-3"
                  icon="pi pi-download"
                  onClick={() => handlePrintPDF('secure_message')}
                />
                <GlobalTooltip tooltip={hasPermission ? '' : 'You are not part of this thread'}>
                  <Button
                    label={'Mark as Unread'}
                    className={'btn-outline p-button-secondary outline py-1 px-3 '}
                    type="button"
                    style={{ overflow: 'inherit' }}
                    onClick={(e) => {
                      handleMarkAsUnRead(e, messageDetails, true);
                    }}
                    disabled={!hasPermission}
                  />
                </GlobalTooltip>
                {checkSubPermission('secure_message_sidebar') ? (
                  <Button
                    label={showSideBar ? 'Close Sidebar' : 'Sidebar'}
                    className="btn-outline p-button-secondary outline py-1 px-3"
                    type="button"
                    style={{ overflow: 'inherit' }}
                    onClick={handleSidebar}
                  >
                    {!showSideBar && newMsg && <span className="indicator-dot" />}
                  </Button>
                ) : null}
                <Button
                  label="Invite Users"
                  className="btn-outline p-button-primary p-button-secondary py-1 px-3 "
                  type="button"
                  onClick={() => {
                    setShowConfirmDialog(true);
                    setShowInviteUsers(true);
                    loadCaseContacts();
                  }}
                />
              </div>
            </div>
          </>
        ) : (
          <div className="d-flex flex-column">
            <div className="d-flex align-items-center">
              <span className="fw-bold me-2">Case:</span>
              <CaseListDropDown
                isClient={isFromClientPortal}
                value={selectedCase}
                caseOnly
                onChange={(e) => {
                  setCaseError('');
                  if (selectedCase !== e) {
                    setSelectedCase(e);
                    if (e?.id) {
                      loadCaseContacts(e?.id);
                    }
                  }
                }}
                name="case"
                className="w-100 new-task-popup invite-user input-shadow"
                placeholder="Search Case"
              />
              <div className="d-flex mt-2 justify-content-end">
                <span
                  className="pointer px-2 border border-1 item-count-center mx-2"
                  onClick={() => {
                    setShowCaseSearch(false);
                    setSelectedCase('');
                    setCaseError('');
                  }}
                >
                  <i className="icon-Close fa-lg"></i>
                </span>
                <span
                  className="pointer px-2 border border-1 item-count-center"
                  onClick={() => {
                    if (selectedCase?.id) {
                      checkCaseRelatedUser(messageDetails?.message_to, caseUserClients);
                      setShowConfirmDialog(true);
                    } else {
                      setCaseError('Select Case');
                      return;
                    }
                  }}
                >
                  <i className="icon-done fa-lg"></i>
                </span>
              </div>
            </div>
            {caseError ? <span className="text-danger">{caseError}</span> : null}
          </div>
        )}
      </div>
    </div>
  );
}

export default CaseName;
